import useReimbursementStore from '../../../screens/Forms/useReimbursementStore';
import { useState } from 'react';

export const DescriptionInput = ({ row, cell, field }) => {
    const [inputValue, setInputValue] = useState(cell);
    const handleChange = (e) => {
        setInputValue(e.target.value);
    };
    const updateRow = useReimbursementStore((state) => state.updateRow);
    const handleTableInputChange = (e) => {
        updateRow(inputValue, field, row.id);
    };

    return (
        <>
            <input
                type='text'
                value={inputValue}
                onChange={handleChange}
                onBlur={handleTableInputChange}
                className='form-control'
                maxLength='250'
            />
        </>
    );
};
